import { Spinner } from 'react-bootstrap';

export default function Loading() {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <Spinner animation="border" variant="primary" style={styles.spinner} />
        <h4 style={styles.text}>Loading...</h4>
      </div>
    </div>
  );
};

const styles = {
  container: {
    height: '100vh',
    width: '100vw',
    background: 'linear-gradient(to right,rgb(0, 0, 0), #e9ecef)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    textAlign: 'center',
    padding: '2rem',
    borderRadius: '1rem',
    backgroundColor: 'white',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
  },
  spinner: {
    width: '3rem',
    height: '3rem',
  },
  text: {
    marginTop: '1rem',
    fontSize: '1.2rem',
    color: '#343a40',
    fontWeight: '500',
  },
};


